/**
 * Refund status label helper — the single place the raw `refund_request_status`
 * value coming from the API is turned into display text.
 *
 * The API stores only the bare action ("Requested", "Accepted", "Rejected",
 * "Canceled"), which on its own reads ambiguously next to a class row: a
 * learner seeing "Requested" or "Canceled" cannot tell whether it refers to the
 * class or to the money. Every screen therefore prints the status through
 * formatRefundStatus() so it always reads "Refund Requested", "Refund
 * Accepted", "Refund Rejected", "Refund Canceled".
 */

// Prefix the status with "Refund" unless it already carries the word, so the
// helper stays safe if the API ever starts sending the full label.
export const formatRefundStatus = (status) => {
  if (status === null || status === undefined) return "";
  const label = String(status).trim();
  if (!label) return "";
  if (/refund/i.test(label)) return label;
  return `Refund ${label}`;
};

export default formatRefundStatus;
